import React, { useCallback } from 'react';

import TextField from '@mui/material/TextField';

import Typography from '@ts-core/components/Typography';
import type { QuestionAnswerType } from '@ts-core/modules/exercises/types';

import { CoreFillInTheBlanksQuestionOption } from '../../types';

interface FillInTheBlanksQuestionBlankProps {
  noColors?: boolean;
  answerType?: QuestionAnswerType;
  answerText?: string;

  blank?: CoreFillInTheBlanksQuestionOption;
  onChange?: (blank: CoreFillInTheBlanksQuestionOption, value: string) => void;
}

const FillInTheBlanksQuestionBlank = (props: FillInTheBlanksQuestionBlankProps) => {
  const { answerText = '', onChange, noColors, answerType, blank } = props;

  const handleChangeText = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange && blank) {
        onChange(blank, event.target.value);
      }
    },
    [onChange, blank]
  );

  return (
    <>
      <TextField
        variant="standard"
        value={answerText}
        disabled={!onChange}
        onChange={handleChangeText}
        sx={(theme) => ({
          marginTop: '-4px',
          backgroundColor: theme.check.palette.exercise.bgcolor(noColors ? undefined : answerType),
          '& .Mui-disabled': {
            color: theme.check.palette.exercise.color(noColors ? undefined : answerType),
            WebkitTextFillColor: theme.check.palette.exercise.color(noColors ? undefined : answerType),
          },
        })}
      />
      {blank?.text && <Typography sx={{ marginRight: '3px' }}>{`(${blank.text})`}</Typography>}
    </>
  );
};

export default FillInTheBlanksQuestionBlank;
